<template lang="html">
  <div>
    <p class="label text-center">
      {{ label }}
    </p>

    <div class="dots-wrapper">
      <div class="dot active" :class="{ completed: step === 2 }"></div>
      <div class="dot last-dot" :class="{ active: step === 2 }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    step: {
      type: Number,
      required: true,
      enum: [1, 2],
    },
  },
}
</script>

<style lang="scss" scoped>
.label {
  color: $color-blue-grey-darken1;
  display: block;
}

.dots-wrapper {
  display: flex;
  width: 40px;
  justify-content: space-between;
  overflow: hidden;
  margin: 8px auto 16px;
}

.dot {
  position: relative;
  width: 13px;
  height: 13px;
  background-color: $color-blue-grey-lighten2;
  border-radius: 50%;
}

.dot.active {
  background-color: $color-blue;
}

.dot.active:before {
  content: '';
  position: absolute;
  width: 25px;
  height: 4px;
  background-color: $color-blue-grey-lighten2;
  top: 5px;
  z-index: 50;
  left: 13px;
  border-top-right-radius: 1.3px;
  border-bottom-right-radius: 1.3px;
}

.dot.active.completed:before {
  background-color: $color-blue;
}
</style>
